import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  borderTop: `1px solid ${greys.borderGrey}`,
  padding: 6,
};
